module.exports = __webpack_public_path__ + "img/logo.5d20cd0d.svg";